import { Rating } from "react-simple-star-rating";
import { Col, Media, Row } from "reactstrap";
import { Btn, H6, Image } from "../../../../AbstractElements";
import { Href } from "../../../../Constants/Constants";
import { WhishListProduct } from "../../../../Data/Applications/ECommerce/ECommerce";
import { dynamicImage } from "../../../../Utils";
import { Link } from "react-router-dom";

export const WishlistData = () => {
  return (
    <Row className="g-sm-4 g-3">
      {WhishListProduct.map((item, index) => (
        <Col xxl="4" md="6" key={index}>
          <div className="prooduct-details-box">
            <Media className="d-flex">
              <Image className="align-self-center img-fluid img-60" src={dynamicImage(`ecommerce/${item.image}`)} alt="#" />
              <Media body className="ms-3 flex-grow-1">
                <div className="product-name">
                  <H6><Link to={Href}>{item.name}</Link></H6>
                </div>
                <Rating initialValue={5} size={17} />
                <div className="price d-flex border-0 p-0">
                  <div className="text-muted me-2">Price</div> : 210$</div>
                <div className="avaiabilty">
                  <div className="text-success">In stock</div>
                </div>
                <div>
                <Btn tag="a" href={Href} color="primary" size="xs">{`MoveToCarts`}</Btn>
                </div>
              </Media>
            </Media>
          </div>
        </Col>
       ))} 
    </Row>
  );
};
